import { ROLE_CONST } from './roleUtils';

export const allowedMimeTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];
export const allowedExtensions = ['.pdf', '.doc', '.docx'];

export const maxSecureFileSize =
  parseInt(process.env.MAX_FILE_SIZE || '0', 10) || 5 * 1024 * 1024; // 5 MB

export const canUploadFile = (fileName: string, mimetype: string) => {
  const fileExt = fileName.split('.').pop()?.toLowerCase();
  const isAllowed =
    allowedMimeTypes.includes(mimetype || '') ||
    (fileExt && allowedExtensions.includes(`.${fileExt}`));
  return isAllowed;
};

export const hasUploadFilePermission = (sessionOrToken) => {
  const allowedRoles = [ROLE_CONST.BoysTownAdmin];

  if (sessionOrToken?.user?.hasOwnProperty('role')) {
    return allowedRoles.includes(sessionOrToken.user.role);
  } else if (sessionOrToken?.hasOwnProperty('user_role')) {
    return allowedRoles.includes(sessionOrToken?.user_role);
  }

  return false;
};
